import { createContext, useContext, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ContactForm } from "@/components/ContactForm";

const Ctx = createContext(() => {});
export const useContact = () => useContext(Ctx);

export function ContactProvider({ children }) {
  const [type, setType] = useState(null);
  return (
    <Ctx.Provider value={setType}>
      {children}
      <Dialog open={!!type} onOpenChange={(o) => !o && setType(null)}>
        <DialogContent className="max-h-[92dvh] overflow-y-auto sm:max-w-xl" data-testid="contact-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-extrabold tracking-tight">Contact Smart-in</DialogTitle>
            <DialogDescription>Tell us what you need and we'll reply by email or phone.</DialogDescription>
          </DialogHeader>
          {type && <ContactForm initialType={type} />}
        </DialogContent>
      </Dialog>
    </Ctx.Provider>
  );
}
